/**
 * 获取指定页面的banner
 * @param name 指定页面
 * @returns banner
 */
export async function fetchBanner(name: string): Promise<Carousel> {
  return http
    .get<Carousel>('/v1/web_content/banner', {
      name
    })
    .then((res) => res.data)
    .catch(() => {
      return {} as Carousel
    })
}
